
export default {
  mounted() {
    this.initHistoryLock();
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopStateLock);
  },
  methods: {
    initHistoryLock() {
      // Push a fresh state so any previous forward stack is discarded.
      try {
        window.history.pushState({ lockForward: true }, document.title, window.location.href);
        window.addEventListener('popstate', this.onPopStateLock);
      } catch (e) {
        // silent
      }
    },
    onPopStateLock(ev) {
      if (ev.state && ev.state.lockForward) {
        // Re-push the same state to neutralize navigation.
        window.history.pushState({ lockForward: true }, document.title, window.location.href);
      }
    },
  }
}